const ExternalKeys = async () =>
    import('../../pages/external-keys/ExternalKeys').then((module) => ({
        Component: module.ExternalKeys,
    }));

const getExternalKeysRouter = (_user, _features) => [
    {
        path: '/external-keys',
        lazy: ExternalKeys,
    },
];

export { getExternalKeysRouter };
